import React, { Suspense, lazy } from 'react';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { Routes, Route } from 'react-router-dom';

// Lazy-load every route so only the active page's code (framer-motion,
// Lottie, videos, images …) lives in memory at any time.  Navigating
// away lets the browser GC the previous page's heavy resources instead
// of keeping them all resident.
const Home = lazy(() => import('./Page/Home'));
const TrackingInterface = lazy(() => import('./components/TrackingInterface'));
const AirTrackingPage = lazy(() => import('./Page/AirTrackingPage'));
const SeaTrackingPage = lazy(() => import('./Page/SeaTrackingPage'));
const CarrierCoveragePage = lazy(() => import('./Page/CarrierCoveragePage'));
const ProfilePage = lazy(() => import('./Page/ProfilePage'));
const UsersPage = lazy(() => import('./Page/UsersPage'));

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tracking" element={<TrackingInterface />} />
          <Route path="/tracking/air" element={<AirTrackingPage />} />
          <Route path="/tracking/sea" element={<SeaTrackingPage />} />
          <Route path="/carrier-coverage" element={<CarrierCoveragePage />} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
        </Routes>
        </Suspense>
      </div>
    </AuthProvider>
  );
}

export default App;
